module.exports = __webpack_public_path__ + "static/media/Ticket.613fc78c.svg";